import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import EventMaster from 'src/utils/EventMaster'
import {
  ZOOM_CONTROLS_ZOOM_IN,
  ZOOM_CONTROLS_ZOOM_OUT,
} from 'src/redux/actions'
import { ZoomBehavior } from '../helpers/ZoomBehavior'

export const useZoomBehavior = ({
  ref,
  isServer,
  props: { width, height },
  handlers,
}) => {
  const router = useRouter()
  const url = router.query
  const instance = new ZoomBehavior(url)
  const [transform, setTransform] = useState(instance.transform)

  const zoomBehavior = useRef(instance)
  const isMounted = useRef(true)

  const isScreenUrl = useMemo(
    () => router.asPath.includes('getScreen'),
    [router]
  )

  const reset = useCallback(() => zoomBehavior.current.reset(), [])
  const zoomIn = useCallback(() => zoomBehavior.current.zoomIn(), [])
  const zoomOut = useCallback(() => zoomBehavior.current.zoomOut(), [])

  useEffect(() => {
    EventMaster.addListener(ZOOM_CONTROLS_ZOOM_IN, zoomIn)
    EventMaster.addListener(ZOOM_CONTROLS_ZOOM_OUT, zoomOut)

    return () => {
      if (!isScreenUrl) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        zoomBehavior.current.reset()
      }

      EventMaster.removeListener(ZOOM_CONTROLS_ZOOM_IN, zoomIn)
      EventMaster.removeListener(ZOOM_CONTROLS_ZOOM_OUT, zoomOut)
      isMounted.current = false
    }
  }, [isScreenUrl, zoomIn, zoomOut])

  useEffect(() => {
    if (ref.current && !isServer) {
      zoomBehavior.current.create({
        rootNode: ref.current,
        width,
        height,

        onZoom: transform => {
          if (isMounted.current) {
            setTransform(transform)
          }
        },
      })
    }

    zoomBehavior.current.setProps({ width, height, url })
  }, [isScreenUrl, height, width, isServer, ref, url])

  useEffect(() => {
    if (zoomBehavior.current) {
      zoomBehavior.current.onStart = handlers.onStart
      zoomBehavior.current.onEnd = handlers.onEnd
    }
  }, [handlers])

  return {
    transform,
    reset,
    isScreenUrl,
  }
}
